import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardHeader, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import Label from '../../../components/label';
import { getAwaiting } from '../store/workflowActions';
import { TYPE_LABELS } from './labels';

/**
 * "N items need your action" -- the first few approvals, receipts and next
 * steps waiting on the signed-in user, from the same query as the Inbox.
 */
export default function AwaitingActionCard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { awaiting, awaitingCount } = useSelector((state) => state.workflowReducer);

  useEffect(() => {
    dispatch(getAwaiting(5));
  }, [dispatch]);

  return (
    <Card>
      <CardHeader
        title={
          awaitingCount
            ? `${awaitingCount} item${awaitingCount === 1 ? '' : 's'} need your action`
            : 'Needs your action'
        }
        action={
          <Button size="small" onClick={() => navigate('/dashboard/inbox')}>
            Open inbox
          </Button>
        }
      />
      {awaiting?.length ? (
        <List dense sx={{ px: 1, pb: 1 }}>
          {awaiting.map((request) => (
            <ListItemButton key={request.id} onClick={() => navigate(`/dashboard/requests/${request.id}`)}>
              <ListItemText
                primary={`${request.reference} — ${request.asset?.description ?? ''}`}
                secondary={request.next_action?.label}
              />
              <Label>{TYPE_LABELS[request.type]}</Label>
            </ListItemButton>
          ))}
        </List>
      ) : (
        <Typography variant="body2" sx={{ px: 3, pb: 3, color: 'text.secondary' }}>
          You are all caught up.
        </Typography>
      )}
    </Card>
  );
}
